import * as yup from 'yup';
import { requiredMsg } from '../../../../Finance/components/TransactionModal/Forms/utils/validationMessages';

export const objectiveSchema = yup.object().shape({
  name: yup.string().required(requiredMsg('Name')).nullable(),
  categoryId: yup.number().nullable(),
  ownerId: yup.number().required(requiredMsg('Owner')).nullable(),
});
